import { createBasicSelector } from 'util/redux'
import { selectPlans } from './selectPlans'

export const selectCurrentPricingIds = createBasicSelector(selectPlans, plans =>
  plans.map(p => p.pricing.id)
)
